import axios from "axios";
import { baseApiUrl } from "../../../env";

import axiosInstance from "../../../Axios/axios";
const baseUrl = `${baseApiUrl}/api/v1/`;
const existToken = localStorage.getItem("accessToken");

const getAllCustomersNameForOrder = async () => {
  let customerNameBody = {
    page: 1,
    totalRecords: 25,
    pageSize: 1000,
    searchTerm: "string",
  };
  const getAllCustomerForOrder_URL = "Customer/GetCustomersForOrder";
  return await axiosInstance.post(getAllCustomerForOrder_URL, customerNameBody);
};

//getAllOrders
const getAllOrders = async (orderBody) => {
    // console.log("🚀 FINAL PAYLOAD:", JSON.stringify(orderBody));

    return await axiosInstance.post(
        "Order/GetAllOrders",
        orderBody
    );
};

const addOrder = async (orderData) => {
  return await axiosInstance.post(
    `${baseApiUrl}/api/v1/Order/AddOrder`,
    orderData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

//   http://192.168.3.17:81/api/v1/Order/UploadOrderFile

const uploadOrderFile = async (orderFile) => {
  // console.log(orderFile)
  return await axiosInstance.post(
    `${baseApiUrl}/api/v1/Order/UploadOrderFile`,
    orderFile,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

// deleteOrder
const deleteOrder = async (id) => {
  const deleteOrder_URL = "Order/DeleteOrder?orderId";
  return await axiosInstance.delete(`${deleteOrder_URL}=${id}`);
};

// getAllDamageCause
const getAllDamageCause = async () => {
  const getAllDamageCause_URL = "Order/GetAllDamageCause";
  return await axiosInstance.get(getAllDamageCause_URL);
};

// getAllApi
const getAllApi = async () => {
  const getAllApi_URL = "Order/GetAllLPI";
  return await axiosInstance.get(getAllApi_URL);
};

// getOrganizationUnit
const getOrganizationUnit = async () => {
  const getOrganizationUnit_URL = "OrganizationUnit/GetAllOrganizationUnit";
  const organzationUnitBody = {
    page: 0,
    totalRecords: 0,
    pageSize: 0,
    searchTerm: "",
  };
  return await axiosInstance.get(getOrganizationUnit_URL, organzationUnitBody);
};

// getOrganUnits
const getOrganizationDepartman = async () => {
  const getOrganUnits_URL = `OrganizationUnit/GetOrganizationUnitForOrder`;
  return await axiosInstance.get(getOrganUnits_URL);
};

// getPrintedInstanceType
const getPrintedInstanceType = async () => {
  const printedInstanceType_URL =
    "PrintedInstanceType/GetAllPrintedInstanceType";
  return await axiosInstance.get(printedInstanceType_URL);
};

// getPrintedInstanceKeepStatus
const getPrintedInstanceKeepStatus = async () => {
  const PrintedInstanceKeepStatus_URL = `PrintedInstanceKeepStatus/GetAllPrintedInstanceKeepStatus`;
  return await axiosInstance.get(PrintedInstanceKeepStatus_URL);
};

// getKlischeTypes
const getKlischeTypes = async ({ queryKey }) => {
  const getKlischeTypes_URL =
    "CustomerFinancial/GetCustomerKlischeType?customerId";
  let id = queryKey[1];
  return await axiosInstance.get(`${getKlischeTypes_URL}=${id}`);
};

// getKlischeThikness
const getKlischeThikness = async ({ queryKey }) => {
  const getKlischeThikness_URL = `CustomerFinancial/GetCustomerKlischeThickness?customerId`;
  let id = queryKey[1];
  return await axiosInstance.get(`${getKlischeThikness_URL}=${id}`);
};

// getCustomerMachineInfo
const getCustomerMachineInfo = async ({ queryKey }) => {
  // console.log(id)
  let id = queryKey[1];
  const getCustomerMachineInfo_URL = "MachineInfo/GetCustomerMachineInfo";
  return await axiosInstance.post(getCustomerMachineInfo_URL, id);
};

// getCustomerMachineInfoDetails
const getCustomerMachineInfoDetails = async ({ queryKey }) => {
  const getCustomerMachineInfoDetails_URL =
    "MachineInfo/GetCustomerMachineInfoDetails?machineId";
  let id = queryKey[1];
  return await axiosInstance.get(`${getCustomerMachineInfoDetails_URL}=${id}`);
};

// getDesignerOfCustomer
const getDesignerOfCustomer = async ({ queryKey }) => {
  let customerId = queryKey[1];
  // console.log(customerId);
  const getDesignerOfCustomer_URL = `Customer/GetDesignersOfCustomer`;
  return await axiosInstance.post(getDesignerOfCustomer_URL, customerId);
};

// getMachineLpi
const getMachineLpi = async ({ queryKey }) => {
  let machineId = queryKey[1];
  const getMachineLpi_URL = `MachineInfo/GetMachineLpi?machineId`;
  return await axiosInstance.get(`${getMachineLpi_URL}=${machineId}`);
};

//
//getLastOrderNumber
const getLastOrderNumber = () => {
  const getLastOrderNumber_URL = "Order/GetLastOrderNumber";
  return axiosInstance.get(`${getLastOrderNumber_URL}`);
};

// getOrderDetails
const getOrderDetails = async (orderId) => {
  const getOrderDetails_URL = `Order/GetSingleOrder`;
  return axiosInstance.post(`${getOrderDetails_URL}`, orderId);
};

// getOrderView
const getOrderView = async (id) => {
  let getOrderView_URL = "Order/GetOrderView?orderId";
  return await axiosInstance.post(`${getOrderView_URL}=${id}`);
};

// deleteOrderImage
const deleteOrderImage = async (id) => {
  const orderImageDelete_URL = `UploadImage/DeleteUploadImage?uploadImageId`;
  return await axiosInstance.delete(`${orderImageDelete_URL}=${id}`);
};

// deleteOrderDepartmanDescription
const deleteOrderDepartmanDescription = async (id) => {
  const deleteOrderDepartmanDescription_URL = `UnitDescription/DeleteUnitDescription?unitDescriptionId`;
  return axiosInstance.delete(`${deleteOrderDepartmanDescription_URL}=${id}`);
};
// http://192.168.3.17:91/api/v1/DesignerGroup/GetAllDesignerGroup

const getAllDesignerGroup = async (id) => {
  const GetAllDesignerGroup_URL = `DesignerGroup/GetAllDesignerGroup`;
  return await axiosInstance.get("DesignerGroup/GetAllDesignerGroup");
};

const getOrderByOrderNumber = async ({ queryKey }) => {
  let id = queryKey[1];
  const orgSendApi = `${baseUrl}Order/GetOrderByOrderNumber?orderNumber=${id}`;
  return await axiosInstance.get(orgSendApi);
};

//   'http://192.168.3.17:81/api/v1/Order/GetSingleOrder'
const getSingleOrder = async ({ queryKey }) => {
  let orderId = queryKey[1];
  const getSingleOrder_URL = "Order/GetSingleOrder";
  return await axiosInstance.post(`${baseUrl}Order/GetSingleOrder`, orderId);
};

// http://192.168.3.17:81/api/v1/Order/UpdateOrder

const updateOrder = async (orderData) => {
  return await axiosInstance.post(
    `${baseApiUrl}/api/v1/Order/UpdateOrder`,
    orderData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

const getAllOrderDeliverInfo = async ({ queryKey }) => {
  let orderId = queryKey[1];
  return await axiosInstance.post(
    `${baseApiUrl}/api/v1/OrderDeliverInfo/GetAllOrderDeliverInfo`,
    orderId
  );
};

const deleteOrderAniluxes = async (orderId) => {
  return await axiosInstance.delete(
    `${baseApiUrl}/api/v1/OrderAniloxes/DeleteOrderAniloxes?orderId=${orderId}`
  );
};

const deleteOrderAnilux = async (aninuxId) => {
  return await axiosInstance.delete(
    `${baseApiUrl}/api/v1/OrderAniloxes/DeleteOrderAnilox?orderAniloxId=${aninuxId}`
  );
};

// http://192.168.3.17:81/api/v1/ColorSelection/UpdateColorsSelection

const updateOrderColors = async (orderColorUpdated) => {
  // console.log(orderColorUpdated)
  return await axiosInstance.post(
    `${baseApiUrl}/api/v1/ColorSelection/UpdateColorsSelection`,
    orderColorUpdated
  );
};
// http://192.168.3.17:81/api/v1/OrderAniloxes/GetOrderAniloxes

const getOrderAniloxes = async ({ queryKey }) => {
  let orderId = queryKey[1];
  return await axiosInstance.post(
    `${baseApiUrl}/api/v1/OrderAniloxes/GetOrderAniloxes`,
    orderId
  );
};
// http://192.168.3.17:81/api/v1/ColorSelection/DeleteColorSelection?id=ed99d94d-b000-ef11-9458-005056897504

const deleteColorSelection = async (colorId) => {
  return await axiosInstance.delete(
    `${baseApiUrl}/api/v1/ColorSelection/DeleteColorSelection?id=${colorId}`
  );
};
// http://192.168.3.17:81/api/v1/ColorSelection/GetColorSelection?orderId=849abd95-3d4f-848c-3d8f-322e981758eb
const getRefreshedOrderColors = async ({ queryKey }) => {
  let orderId = queryKey[1];
  return await axiosInstance.get(
    `${baseApiUrl}/api/v1/ColorSelection/GetColorSelection?orderId=${orderId}`
  );
};
// http://192.168.3.17:81/api/v1/PrintedInstanceTrace/DeletePrintedInstanceTrace?id=17e9210e-ac00-ef11-9458-005056897504

const deleteOrderPrintedInstance = async (instanceId) => {
  // http://192.168.3.17:81/api/v1/PrintedInstanceTrace/DeletePrintedInstanceTrace
  return await axiosInstance.post(
    `${baseApiUrl}/api/v1/PrintedInstanceTrace/DeletePrintedInstanceTrace`,
    instanceId
  );
};


const getOrderDamageByOrderId = async ({ queryKey }) => {
  let orderId = queryKey[1];
  return await axiosInstance.get(
    `${baseApiUrl}/api/v1/OrderDamage/GetOrderDamageByOrderId?orderDamageId=${orderId}`
  );
};

const AssignReturnsToOrder = async (body) => {
// http://192.168.3.17:91/api/v1/OrderReturn/AssignReturnsToOrder

  return await axiosInstance.post(
    `${baseApiUrl}/api/v1/OrderReturn/AssignReturnsToOrder`,
    body
  );
};



// http://192.168.3.17:91/api/v1/OrderReturn/GetOrderReturnsByOrderId?orderId=3fa85f64-5717-4562-b3fc-2c963f66afa6
const GetOrderReturnsByOrderId = async ({queryKey}) => {
  let orderId=queryKey[1];
  // console.log(orderId,'orderIdorderIdorderIdorderIdorderIdorderIdorderId')
  return await axiosInstance.get(
    `${baseApiUrl}/api/v1/OrderReturn/GetOrderReturnsByOrderId?orderId=${orderId}`
  );
};



export {
  getAllCustomersNameForOrder,
  getAllOrders,
  addOrder,
  uploadOrderFile,
  deleteOrder,
  getAllDamageCause,
  getAllApi,
  getOrganizationUnit,
  getPrintedInstanceType,
  getPrintedInstanceKeepStatus,
  getKlischeTypes,
  getKlischeThikness,
  getCustomerMachineInfo,
  getCustomerMachineInfoDetails,
  getDesignerOfCustomer,
  getOrganizationDepartman,
  getMachineLpi,
  getLastOrderNumber,
  getOrderDetails,
  getOrderView,
  deleteOrderImage,
  deleteOrderDepartmanDescription,
  getOrderByOrderNumber,
  getSingleOrder,
  updateOrder,
  getAllOrderDeliverInfo,
  deleteOrderAnilux,
  deleteOrderAniluxes,
  updateOrderColors,
  getOrderAniloxes,
  deleteColorSelection,
  getRefreshedOrderColors,
  deleteOrderPrintedInstance,
  getAllDesignerGroup,
  getOrderDamageByOrderId,
  AssignReturnsToOrder,
  GetOrderReturnsByOrderId
};
